const BillDiscount = {
  validHeader: {
    'Program Id': 'program_id',
    'Days Early': 'days_early',
    'Discount Rate': 'discount_rate',
  },
  optionalHeader: {},
  validationLabel: {
    PROGRAM_ID: 'Program Id',
    DAYS_EARLY: 'Days Early',
    DISCOUNT_RATE: 'Discount Rate',
  },
  errorLabels: {
    INVALID_PROGRAM_ID: 'Invalid Program Id',
    INVALID_DAYS_EARLY: 'Invalid Days Early',
    INVALID_DISCOUNT_RATE: 'Invalid Discount Rate',
  },
};
module.exports = { BillDiscount };
